// VerticalSliderControlView.js

import { View } from 'backbone';
import BaseControlView from 'BaseControlView.js';
import constants        from "Constants.js";
import template from 'advanced-inputs/control_vertical_slider.ejs';

class VerticalSliderControlView extends BaseControlView {
    initialize(opts){
        super.initialize( opts );
        this.template = template;
        this.tagName = 'div'; 
        this.family = constants.CONTROL_ADVANCED_INPUTS;
        this.icon = 'pf-vertical-slider';
        this.events = {};

        this.listenTo(this.model, 'change', this.render);

        return this;
    }
    get kind() { return 'VerticalSliderControlView'; }
}

export default VerticalSliderControlView;